import { render } from "./ConsumerHeaderStyleEditor.vue?vue&type=template&id=6aa6ea68"
import script from "./ConsumerHeaderStyleEditor.vue?vue&type=script&lang=js"
export * from "./ConsumerHeaderStyleEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__